import { createFileRoute } from "@tanstack/react-router";
import { LegalPageLayout } from "@/components/legal-page-layout";
import { COMPANY } from "@/lib/company-info";

export const Route = createFileRoute("/yasal/iade-iptal")({
  head: () => ({
    meta: [
      { title: "İade & İptal Politikası — JUËN" },
      { name: "description", content: "Etkinlik bileti, üyelik ve içecek kuponları için iade ve iptal koşulları." },
      { property: "og:title", content: "İade & İptal Politikası — JUËN" },
      { property: "og:description", content: "Etkinlik bileti, üyelik ve içecek kuponları için iade ve iptal koşulları." },
    ],
  }),
  component: Page,
});

function Page() {
  return (
    <LegalPageLayout title="İade & İptal Politikası" lastUpdated="01.05.2026">
      <h2>1. Genel İlke</h2>
      <p>
        {COMPANY.brandName} üzerinden satın alınan etkinlik biletleri, üyelik paketleri ve içecek
        kuponları, 6502 sayılı Tüketicinin Korunması Hakkında Kanun ve Mesafeli Sözleşmeler
        Yönetmeliği'nin 15. maddesi uyarınca <strong>belirli bir tarihte yapılması gereken
        eğlence hizmetleri</strong> kapsamına girdiğinden cayma hakkı dışında bırakılmıştır.
      </p>

      <h2>2. Kullanıcı Kaynaklı İptal Talepleri</h2>
      <p>
        ALICI'nın etkinliğe katılamaması, fikir değiştirmesi veya benzeri kişisel sebeplerle
        yapılan iptal taleplerinde <strong>iade yapılmamaktadır</strong>. Satın alınan biletler
        ve kuponlar geçerliliğini etkinlik tarihine kadar korur.
      </p>

      <h2>3. SATICI Kaynaklı İptaller</h2>
      <p>
        Etkinliğin {COMPANY.brandName} tarafından iptal edilmesi, ertelenmesi veya esaslı
        değişikliğe uğraması durumunda:
      </p>
      <ul>
        <li>Ödenen tutarın <strong>%100'ü</strong> ALICI'ya iade edilir.</li>
        <li>İade, ödeme yapılan aynı yöntemle (kredi kartına geri ödeme, banka havalesi vb.) gerçekleştirilir.</li>
        <li>İade işlemi, iptal duyurusundan itibaren <strong>en geç 14 iş günü</strong> içinde başlatılır. Bankanın iadeyi kart hesabınıza yansıtma süresi 2-10 iş gününü bulabilir.</li>
        <li>Etkinlik ertelenirse, ALICI yeni tarihte aynı bileti kullanmayı kabul edebilir veya iade talep edebilir.</li>
      </ul>

      <h2>4. Üyelik İptali</h2>
      <p>
        Üyelik paketi satın alan kullanıcılar, üyelikten istedikleri zaman çıkış yapabilir;
        ancak başlamış üyelik dönemi için iade yapılmaz. Yenilenmeyen üyelikler dönem sonunda
        otomatik sona erer.
      </p>

      <h2>5. İçecek Kuponları</h2>
      <p>
        Satın alınan içecek kuponları yalnızca alındığı etkinlik kapsamında kullanılabilir.
        Kullanılmayan kuponlar etkinlik tarihinden sonra geçersiz olur ve iadeye konu edilemez.
        Etkinlik iptali halinde kullanılmamış kuponların bedeli iade edilir.
      </p>

      <h2>6. Hatalı / Yanlış Sipariş</h2>
      <p>
        Sistem hatası, mükerrer ödeme veya {COMPANY.brandName}'in hatasından kaynaklanan yanlış
        siparişler tespit edildiğinde ALICI'nın talebi üzerine ücret iadesi yapılır. Bu tür
        durumları aşağıdaki iletişim kanalı üzerinden sipariş numaranızla bildiriniz.
      </p>

      <h2>7. İade Talebi Nasıl Yapılır?</h2>
      <p>
        İade talepleri WhatsApp üzerinden yazılı olarak iletilmelidir. Talebinizde aşağıdaki
        bilgileri belirtmeniz gerekir:
      </p>
      <ul>
        <li>Sipariş numarası</li>
        <li>Üyelik e-posta adresiniz</li>
        <li>İade gerekçesi</li>
        <li>Ödeme yaptığınız kart/hesap bilgileri (gerekiyorsa)</li>
      </ul>

      <h2>8. İletişim</h2>
      <p>
        İade ve iptalle ilgili tüm sorularınız için WhatsApp: {COMPANY.phone}
      </p>
    </LegalPageLayout>
  );
}
